export enum Colors {
  red = 'red',
  pink = 'pink',
  purple = 'purple',
  deepDurple = 'deepPurple',
  indigo = 'indigo',
  blue = 'blue',
  lightBlue = 'lightBlue',
  cyan = 'cyan',
  teal = 'teal',
  green = 'green',
  lightGreen = 'lightGreen',
  lime = 'lime',
  yellow = 'yellow',
  amber = 'amber',
  orange = 'orange',
  deepOrange = 'deepOrange',
  brown = 'brown',
  grey = 'grey',
  blueGrey = 'blueGrey',
}

export enum AgeGroupType {
  neo = 'Neo',
  pediatric = 'Pediatric',
  adults = 'Adults',
}

export interface AgeGroup {
  ageGroupId: string;
  name: string;
  type: AgeGroupType;
  maxAge: number;
  maxWeight: number;
  color: Colors;
  observations?: string;
}

export const AgeGroupTypeNameMap = new Map<AgeGroupType, string>([
  [AgeGroupType.neo, 'Neo'],
  [AgeGroupType.pediatric, 'Pediátrico'],
  [AgeGroupType.adults, 'Adulto'],
]);

export const AgeGroupTypeNameReverseMap = new Map<string, AgeGroupType>(
  Array.from(AgeGroupTypeNameMap, ([key, value]) => [value, key])
);

export const AgeGroupTypeColorMap = new Map<AgeGroupType, Colors>([
  [AgeGroupType.neo, Colors.amber],
  [AgeGroupType.pediatric, Colors.cyan],
  [AgeGroupType.adults, Colors.purple],
]);

export const AgeGroupTypeColorReverseMap = new Map<Colors, AgeGroupType>(
  Array.from(AgeGroupTypeColorMap, ([key, value]) => [value, key])
);
